/** Script editor toolbar icon buttons (LipSync + Talking Photo generators). */

const TOOL_ICON_BASE =
  "inline-flex size-8 shrink-0 items-center justify-center rounded-lg border-0 bg-[var(--ui-panel-hover)] text-ui-fg-secondary transition-colors duration-200 ease-in-out hover:bg-ui-surface hover:text-primary-600 dark:bg-ui-elevated dark:text-ui-fg-secondary dark:hover:bg-ui-surface-muted dark:hover:text-primary-400 active:bg-primary-600/14 active:text-primary-600 dark:active:bg-primary-500/18 dark:active:text-primary-400 disabled:cursor-not-allowed disabled:opacity-[0.55]";

const TOOL_ICON_THEME =
  "bg-primary-600/14 text-primary-600 ring-1 ring-primary-500/35 dark:bg-primary-500/18 dark:text-primary-400 dark:ring-primary-400/40";

/** @param {{ active?: boolean; loading?: boolean }} [opts] */
export function toolIconClass({ active = false, loading = false } = {}) {
  if (loading) {
    return `${TOOL_ICON_BASE} pointer-events-none cursor-wait ${TOOL_ICON_THEME}`;
  }
  if (active) {
    return `${TOOL_ICON_BASE} ${TOOL_ICON_THEME}`;
  }
  return TOOL_ICON_BASE;
}

export const TOOL_ICON_SPINNER_TRACK =
  "absolute size-4 text-primary-600/35 dark:text-primary-400/40";

export const TOOL_ICON_SPINNER =
  "size-4 animate-spin text-primary-600 dark:text-primary-400";

/** AI Script pill button — idle / active (open) / loading */
export function aiScriptBtnClass({ open = false, loading = false } = {}) {
  const idle =
    "border-ui-border bg-ui-surface text-ui-fg hover:bg-ui-surface-muted hover:text-primary-600 dark:bg-ui-elevated dark:hover:bg-ui-surface-muted dark:hover:text-primary-400 active:bg-primary-600/14 active:text-primary-600 dark:active:bg-primary-500/18 dark:active:text-primary-400";
  const theme =
    "border-primary-500/55 bg-primary-600/14 text-primary-600 ring-1 ring-primary-500/35 dark:border-primary-400/50 dark:bg-primary-500/18 dark:text-primary-400 dark:ring-primary-400/40";
  if (loading) {
    return `pointer-events-none cursor-wait ${theme}`;
  }
  if (open) {
    return theme;
  }
  return idle;
}

export const AI_SCRIPT_BTN_BASE =
  "inline-flex h-8 items-center gap-1 rounded-lg border px-2 text-xs font-semibold transition";
